import React from 'react'

import { EChart } from '@/components/charts/EChart'
import { buildBulletOption } from '@/components/charts/nivoToEcharts.helpers'
import { CHART } from '@/components/charts/chartPalette'
import { thresholdColors } from '@/utils/constants'

// Renders on ECharts but keeps the nivo bullet data shape
// ([{ id, ranges, measures }]): threshold ranges as a stacked background
// track with the measure bar overlaid.
const BulletChart = ({ data }) => (
  <EChart
    option={buildBulletOption({
      data,
      rangeColors: thresholdColors,
      measureColors: [CHART.BRAND],
      margin: { top: 50, right: 50, bottom: 50, left: 120 },
    })}
    style={{ width: '100%', height: '100%' }}
  />
)

export default BulletChart
